module.exports = __webpack_public_path__ + "img/父母糖尿病家族史@2x.7092a0ef.png";